import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Lightbulb, ChevronDown, Plus, EyeOff, MessageSquareWarning, Star } from 'lucide-react';
import { Button } from '../../ui/button';

const Suggestion = ({ s, onCreer, onIgnorer }) => {
  const Icone = s.origine === 'reclamation' ? MessageSquareWarning : Star;
  return (
    <li className="flex flex-col gap-2 rounded-lg border border-amber-200 bg-white p-3 sm:flex-row sm:items-center" data-testid={`suggestion-${s.ref}`}>
      <Icone className="hidden h-5 w-5 shrink-0 text-amber-600 sm:block" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium text-[#0F172A]">{s.constat}</p>
        <p className="text-xs text-slate-500">{s.origine_libelle}</p>
      </div>
      <div className="flex shrink-0 gap-1">
        <Button size="sm" onClick={() => onCreer(s)} className="bg-[#8DC63F] text-[#0F172A] hover:bg-[#7AB534]" data-testid={`suggestion-creer-${s.ref}`}><Plus className="h-4 w-4 mr-1" /> Créer l'action</Button>
        <Button size="sm" variant="ghost" onClick={() => onIgnorer(s)} className="text-slate-500" data-testid={`suggestion-ignorer-${s.ref}`}><EyeOff className="h-4 w-4 mr-1" /> Ignorer</Button>
      </div>
    </li>
  );
};

export const Suggestions = ({ items, onCreer, onChanged }) => {
  const [ouvert, setOuvert] = useState(true);
  const ignorer = async (s) => {
    try { await axios.post('/qualiopi/actions/suggestions/ignorer', { ref: s.ref }); toast.success('Suggestion ignorée'); onChanged(); } catch { toast.error('Impossible d\'ignorer la suggestion'); }
  };
  return (
    <div className="rounded-2xl border border-amber-200 bg-amber-50/60" data-testid="suggestions">
      <button type="button" onClick={() => setOuvert(!ouvert)} className="flex w-full items-center gap-3 p-4 text-left" data-testid="suggestions-toggle">
        <Lightbulb className="h-5 w-5 text-amber-600" />
        <span className="flex-1">
          <span className="block text-sm font-semibold text-[#0F172A]">Suggestions automatiques ({items.length})</span>
          <span className="block text-xs text-slate-500">Questions de satisfaction notées sous 3/5 et réclamations sans action d'amélioration</span>
        </span>
        <ChevronDown className={`h-4 w-4 text-slate-400 transition-transform ${ouvert ? 'rotate-180' : ''}`} />
      </button>
      {ouvert && (items.length === 0
        ? <p className="px-4 pb-4 text-sm text-slate-500" data-testid="suggestions-vide">Rien à signaler : aucune note sous 3/5 et chaque réclamation a son action (ou a été ignorée).</p>
        : <ul className="space-y-2 px-4 pb-4">{items.map((s) => <Suggestion key={s.ref} s={s} onCreer={onCreer} onIgnorer={ignorer} />)}</ul>)}
    </div>
  );
};
